document.addEventListener('DOMContentLoaded', function () {
    const cartTriggers = document.querySelectorAll('.wiacc-show-cartlayer');

    if (cartTriggers.length > 0) {
        cartTriggers.forEach(cartTrigger => {
            cartTrigger.addEventListener('click', function () {
                const delay = parseInt(this.getAttribute('data-timer')) || 400;
                const targetClass = this.getAttribute('data-target');

                setTimeout(() => {
                    disableScroll();
                    handleEscapeClose();
                    handleFocusTrap(cartTrigger, targetClass);
                }, delay);
            });
        });
    }
});
